import {
    successState,
    errorState,
    loadingState,
    initalState,
} from 'api/defaultStates'
import { actionStates } from 'api/helpers'
import {
    GET_TECHNOLOGIES,
    GET_TECHNOLOGY_STATS,
    FILTER_TECHNOLOGIES,
    GET_MORE_TECHNOLOGIES,
} from './actions'
import { combineReducers } from 'redux'

export function getTechnologies(state = initalState, action) {
    switch (action.type) {
        case actionStates(GET_TECHNOLOGIES).success:
            return { ...successState, data: action.data?.data?.result, count: action.data?.data?.total_count, nextPage: 2}
        case actionStates(GET_TECHNOLOGIES).isLoading:
            return { ...state, ...loadingState, data: state.data }
        case actionStates(GET_TECHNOLOGIES).error:
            return { ...errorState, error: action.error }
        case actionStates(GET_TECHNOLOGIES).reset:
            return { ...initalState }

        // State handling for filter actions
        case actionStates(FILTER_TECHNOLOGIES).success:
            return { ...state, ...successState, data: action.data?.data?.result, count: action.data?.data?.total_count, nextPage: 2 }

        case actionStates(GET_MORE_TECHNOLOGIES).success:
            return {
                ...state,
                ...successState,
                nextPage: action.data?.data?.result?.length > 0 && state.nextPage + 1,
                data: [
                    ...((state.data && state.data) || []),
                    ...((action.data?.data && action.data.data.result) || []),
                ],
            }

        default:
            return state
    }
}

export function getTechnologyStats(state = initalState, action) {
    switch (action.type) {
        case actionStates(GET_TECHNOLOGY_STATS).success:
            return { ...successState, data: action.data?.data?.result }
        case actionStates(GET_TECHNOLOGY_STATS).isLoading:
            return { ...loadingState, loading: true }
        case actionStates(GET_TECHNOLOGY_STATS).error:
            return { ...errorState, error: action.error }
        default:
            return state
    }
}

export default combineReducers({
    list: getTechnologies,
    stats: getTechnologyStats,
})
